import Phaser from 'phaser';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import ABCyaPhaser from '@abcya/abcya_phaser';
import MenuPopup from '../ui/MenuPopup';
import { printSave } from '../game/savePrint';
import DrawArea from '../game/DrawArea';
import ToolPanel from '../ui/ToolPanel';

export default class Game extends Phaser.Scene {
  static get KEY() { return 'Game'; }

  create() {
    // set default tools (draw, small, black);
    gameData.CURRENT_TOOL = 'draw';
    gameData.DRAW_COLOR = '0x000000';
    gameData.DRAW_SIZE = 'small';

    this.mid = ABCyaPhaser.Scene.getScreenMidPoint(this);

    const bg = this.add.rectangle(0, 0, this.mid.x * 2, this.mid.y * 2,'0x9E979E').setOrigin(0);

    const gridSize = gameData.GAME_ORIENTATION === 'Portrait' ? 48 : 100;
    this.drawArea = new DrawArea(this, gridSize);
    this.drawArea.x = this.mid.x - (this.drawArea.areaWidth / 2);
    this.drawArea.y = 20;
    this.add.existing(this.drawArea);

    this.toolBox = new ToolPanel(this);
    this.add.existing(this.toolBox);
    this.toolBox.on('UI_CLICK', (btn) => {this.handleUi(btn);});
  }

  startGame() {
    this.drawReady = true;
  };

  restartGame() {
    this.scene.start();
  };

  handleUi(e) {
    switch (e) {
      case 'menu':
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pixel_art_select_sound, this);
        this.showMenu();
        break;
      case 'grid':
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pixel_art_select_sound, this);
        this.drawArea.toggleGrid();
        break;
      case 'undo':
        this.drawArea.drawGrid.undoAction();
        break;
    }
  };

  showMenu() {
    if (this.menuPopUp) return;

    this.menuPopUp = new MenuPopup(this);
    this.menuPopUp.x = this.mid.x - (this.menuPopUp.popupWidth / 2);
    this.menuPopUp.y = this.mid.y - (this.menuPopUp.popupHeight / 2);
    this.add.existing(this.menuPopUp);

    this.menuPopUp.once('MENU_CLICK', (btn) => {this.closeMenu(btn);});
  };

  closeMenu(e) {
    if (e.btnId === 'save' || e.btnId === 'print') {
      this.shareDrawing(e.btnId);

      this.menuPopUp.destroy();
      this.menuPopUp = null;
    }
    else if (e.btnId === 'new') {
      this.menuPopUp.destroy();
      this.menuPopUp = null;

      this.restartGame();
    }
    else {
      this.menuPopUp.destroy();
      this.menuPopUp = null;
    }
  };

  shareDrawing(shareType) {
    if (shareType === 'save') {
      printSave('save', this.drawArea);
    }
    else {
      printSave('print', this.drawArea);
    }
  };
}